module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', [_vm._l((_vm.blowbends), function(note, index) {
    return (note && note.pitch) ? [_c('harmap-cell', {
      key: note,
      attrs: {
        "x": _vm.xCoord(),
        "y": _vm.yCoordBlowbend(index),
        "pitch": note.pitch,
        "type": note.type
      }
    })] : _vm._e()
  }), _vm._v(" "), _c('harmap-cell', {
    attrs: {
      "x": _vm.xCoord(),
      "y": _vm.yCoordBlownote(),
      "pitch": _vm.blownote,
      "type": "natural"
    }
  }), _vm._v(" "), _c('harmap-hole-number', {
    attrs: {
      "x": _vm.xCoord(),
      "y": _vm.yCoordHolenumber(),
      "text": _vm.holeNumber + 1
    }
  }), _vm._v(" "), _c('harmap-cell', {
    attrs: {
      "x": _vm.xCoord(),
      "y": _vm.yCoordDrawnote(),
      "pitch": _vm.drawnote,
      "type": "natural"
    }
  }), _vm._v(" "), _vm._l((_vm.drawbends), function(note, index) {
    return (note && note.pitch) ? [_c('harmap-cell', {
      key: note,
      attrs: {
        "x": _vm.xCoord(),
        "y": _vm.yCoordDrawbend(index),
        "pitch": note.pitch,
        "type": note.type
      }
    })] : _vm._e()
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76af3f9d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HarmapCol.vue
// module id = 100
// module chunks = 1